// removed by extract-text-webpack-plugin
module.exports = {"label-top":"credit-chart-v2--label-top--63IQ9P3w","labelTop":"credit-chart-v2--label-top--63IQ9P3w","label-center":"credit-chart-v2--label-center--2JWtpKKq","labelCenter":"credit-chart-v2--label-center--2JWtpKKq","label-bottom":"credit-chart-v2--label-bottom--2KwNzCw_","labelBottom":"credit-chart-v2--label-bottom--2KwNzCw_"};


//////////////////
// WEBPACK FOOTER
// ./components/credit-chart-v2/styles.css
// module id = ./components/credit-chart-v2/styles.css
// module chunks = 0